import { useLogin, useLogout } from "@refinedev/core";
import { Button, Form, FormInstance, Input } from "antd";
import React, { useRef, useState } from "react";
import { emailPassLogin, verifyOTP } from "api/consumerLogin";
import { VALIDATION } from "constants/strings";
import AuthScreenContainer from "containers/AuthScreenContainer";
import { useNavigate } from "react-router-dom";
import { OtpForm } from "../Otp/Otp";
import classes from "./Login.module.css";

export const LoginForm: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [showOtp, setShowOtp] = useState(false);
  const [email, setEmail] = useState("");

  const navigate = useNavigate();
  const { mutate: login } = useLogin();
  const { mutate: logout } = useLogout();

  const formRef = useRef<FormInstance>(null);

  const handleSignIn = async () => {
    try {
      await formRef.current?.validateFields();
    } catch (e) {
      return;
    }

    setLoading(true);
    const formData = formRef.current?.getFieldsValue();
    const response = await emailPassLogin(formData);
    setLoading(false);

    if (response?.emailVerified === false) {
      setEmail(formData.email);
      setShowOtp(true);
      return;
    } else if (!response) return;

    const role = response?.data?.role?.type;
    const isAdmin = role === "admin";

    if (!isAdmin && !response.data.approved) {
      logout();
      navigate("/account-pending", {
        replace: true,
        state: { email: formData.email }
      });
      return;
    }

    if (!isAdmin && !response.data.isOnboarded) {
      navigate("/onboarding", {
        replace: true,
        state: { email: formData.email }
      });
      return;
    }

    if (role === "external" || role === "client") {
      login({ role: "user", token: "user" });
      return;
    }
    if (role === "admin") {
      login({ role: "admin", token: "admin" });
      return;
    }
  };

  if (showOtp) {
    return (
      <OtpForm
        email={email}
        next={(data: any) => {
          navigate("/jobs");
        }}
        verify={verifyOTP}
      />
    );
  }

  return (
    <AuthScreenContainer
      heading="Sign in"
      footerText="Don't have an account?"
      footerLink="/register"
      footerLinkText={"Sign up"}>
      <Form requiredMark={false} onFinish={handleSignIn} ref={formRef} layout="vertical">
        <Form.Item
          label={"Email"}
          name="email"
          rules={[
            {
              type: "email",
              message: VALIDATION.invalidEmail
            },
            {
              required: true,
              message: VALIDATION.fieldIsRequired
            }
          ]}>
          <Input type="email" />
        </Form.Item>
        <Form.Item
          label={"Password"}
          name="password"
          rules={[
            {
              required: true,
              whitespace: true,
              message: VALIDATION.fieldIsRequired
            }
          ]}>
          <Input.Password type="password" />
        </Form.Item>
        <h6 className={classes.forgetPassword} onClick={() => navigate("/forgot-password")}>
          Forgot Password?
        </h6>
        <Button
          htmlType="submit"
          loading={loading}
          disabled={loading}
          onClick={() => {
            formRef.current?.submit();
          }}
          style={{
            width: "100%",
            height: "56px",
            fontSize: "20px",
            fontWeight: 600,
            textAlign: "center",
            lineHeight: "29px",
            borderRadius: "8px"
          }}>
          Sign In
        </Button>
      </Form>
    </AuthScreenContainer>
  );
};
